import { render, staticRenderFns } from "./ProjectInvitationsDescTile.vue?vue&type=template&id=22e5e6ae&scoped=true&lang=pug&"
import script from "./ProjectInvitationsDescTile.vue?vue&type=script&lang=js&"
export * from "./ProjectInvitationsDescTile.vue?vue&type=script&lang=js&"
import style0 from "./ProjectInvitationsDescTile.vue?vue&type=style&index=0&id=22e5e6ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e5e6ae",
  null
  
)

export default component.exports